"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initModalTakeoverWidget = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactModal = _interopRequireDefault(require("react-modal"));

var _useLocalStorage3 = require("./lib/useLocalStorage");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: -30px;\n  right: 0;\n  font-size: 16px;\n  color: white;\n  background: none;\n  border: none;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  width: 90vw;\n  padding-bottom: 56%;\n\n  @media (min-width: 769px) {\n    width: 800px;\n  }\n\n  @media (min-width: 1400px) {\n    width: 900px;\n  }\n  iframe {\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var customStyles = {
  content: {
    top: '20%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%)',
    padding: 0,
    background: 'none',
    border: 'none',
    overflow: 'visible'
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,.5)',
    zIndex: 13
  }
};

var Container = _styledComponents.default.div(_templateObject());

var CloseButton = _styledComponents.default.button(_templateObject2());

function App() {
  var _useLocalStorage = (0, _useLocalStorage3.useLocalStorage)('modal-takeover-widget-hide'),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      hideModaltakeoverWidget = _useLocalStorage2[0],
      setHideModaltakeoverWidget = _useLocalStorage2[1];

  if (hideModaltakeoverWidget === 'true') {
    return null;
  }

  return /*#__PURE__*/_react.default.createElement(_reactModal.default, {
    isOpen: !hideModaltakeoverWidget,
    contentLabel: "Inline Styles Modal Example",
    style: customStyles,
    onRequestClose: function onRequestClose() {
      return setHideModaltakeoverWidget('true');
    }
  }, /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement("iframe", {
    src: "https://www.youtube.com/embed/OElWllLQ4fA?autoplay=1&modestbranding=1&rel=0&fs=0",
    frameborder: "0"
  })), /*#__PURE__*/_react.default.createElement(CloseButton, {
    onClick: function onClick() {
      setHideModaltakeoverWidget('true');
    }
  }, "Close"));
}

var mountApp = function mountApp(id) {
  var mountNode = document.getElementById(id);

  _reactDom.default.render( /*#__PURE__*/_react.default.createElement(App, null), mountNode);
};

var initModalTakeoverWidget = function initModalTakeoverWidget(bus) {
  var onEvent = function onEvent(_ref) {
    var type = _ref.type,
        payload = _ref.payload;

    if (type === 'mount' && payload.name === 'modal-takeover-widget') {
      mountApp(payload.id);
    }
  };

  bus.subscribe(onEvent);
};

exports.initModalTakeoverWidget = initModalTakeoverWidget;